module.exports = __webpack_public_path__ + "img/del.24fd2b46.jpg";